export const UPLOAD_CONTENT_TYPE = {
    WEB_DOCUMENT: 'WebDocument',
    WEB_PHOTO: 'WebPhoto',
    WEB_VIDEO: 'WebVideo',
};

export const UPLOAD_LINKED_FILTER = {
    ALL: 'all',
    LINKED: 'yes',
    ORPHAN: 'no',
};

export const UPLOAD_LINKED_FILTER_OPTIONS = [
    { label: 'All', value: UPLOAD_LINKED_FILTER.ALL },
    { label: 'Yes', value: UPLOAD_LINKED_FILTER.LINKED },
    { label: 'No', value: UPLOAD_LINKED_FILTER.ORPHAN },
];
